import { type RouterSpecsFragment } from '../../../api/fragments/RouterSpecs';
import EndpointsTable from './EndpointsTable';
import Layout from './Layout';
import MenuItem from './menuItems';
import NoEndpointResult from './NoEndpointResult';

export type RouterTabsProps = {
    router: RouterSpecsFragment;
    activeTab: string;
};

const RouterTabs = ({ router, activeTab }: RouterTabsProps) => {
    switch (activeTab) {
        case 'layout':
            return <Layout router={router} />;

        case 'endpoints': {
            if (router.endpoints.length === 0) {
                return <NoEndpointResult router={router} />;
            }

            return <EndpointsTable router={router} />;
        }

        case 'menu':
            return <MenuItem router={router} />;

        default:
            throw new Error('Unsupported tab');
    }
};

export default RouterTabs;
